/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import SuccessScreen from "./SuccessScreen.container";

export default SuccessScreen;
